import { SharedLOAInformation } from 'views/shared/LOAInformation';
import {
  changePolicyInformation,
  changeMethodOfPayment,
  removeMissingMandatoryField,
  addMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/homePersonalFormReducer';
import { SECTIONS } from 'views/home_form/constants';

const LOAInformation = () => {
  return (
    <SharedLOAInformation
      formStateKey="homePersonalForm"
      formActions={{
        changePolicyInformation,
        changeMethodOfPayment,
        removeMissingMandatoryField,
        addMissingMandatoryField,
        addRemark,
        removeRemark,
        updateRemark,
        addFile,
        removeFile,
      }}
      sectionId={SECTIONS.POLICY_INFORMATION}
    />
  );
};

export default LOAInformation;
